import rhinoCore from 'rhino/src/core/core.module';
import * as rnRequestService from './request.service';

export default angular.module('rhino.components.request', [rhinoCore])
  .service(rnRequestService.name, rnRequestService.default)
  .name;




// WEBPACK FOOTER //
// ../~/@printos/rhino/src/components/request/request.module.js